module.exports = __webpack_public_path__ + "static/f922c7f113822c538ac7b1551bfd26f843b5a2038f9f278e596e310680cb1839-a393b66c6975e8bf545e428caabe4c4a.jpeg";